export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://esprime.arture.dev/";
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://esprime.arture.dev/backend/api";

export const API_TIMEOUT_MS = 15000;

export const BASE_FOLDER = "management";

export const WOO_URL =
  process.env.REACT_APP_WOO_URL || "https://esprime.arture.dev";
export const WOO_API_KEY =
  process.env.REACT_APP_WOO_API_KEY ||
  "ck_f0b29b16a536dcab508076d1c83a63eddf2fb54d";
export const WOO_API_SECRET =
  process.env.REACT_APP_WOO_API_SECRET ||
  "cs_7c7ed082baa023731478753d1f32b0deaa87f4d1";
